module.exports = __webpack_public_path__ + "assets/images/amountofPlants-04.9b285eb5e5ca57ed3c75c0941ec0507e.svg";